import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";

function PickerAutocomplete({
  defaultValue,
  newValues,
  error,
  placeholder,
  options,
  ...props
}) {
  return (
    <div>
      <Autocomplete
        size="small"
        options={options}
        getOptionLabel={(option) => `${option.code} ${option.name}`}
        defaultValue={defaultValue}
        onChange={(event, newValue) => {
          newValues(newValue);
        }}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholder} />
        )}
        {...props}
      />

      {error && (
        <Typography variant="caption" color="red">
          {error}
        </Typography>
      )}
    </div>
  );
}

export default PickerAutocomplete;
